import { c as _c } from "react/compiler-runtime";
import type { CarInfo } from '@sbt-web/network/types';
import { Accordion } from '@sbt-web/ui';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { AccordionIcon } from './AccordionIcon';
import { AccordionTitle } from './AccordionTitle';
import { AccordionContent } from './AccordionContent';
const ACCORDION_ID = 'infocar-details';
export type Props = {
  infocarData: CarInfo | null;
};
const Infocar = t0 => {
  const $ = _c(4);
  const {
    infocarData
  } = t0;
  if (!infocarData || infocarData.length === 0) {
    return null;
  }
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AccordionIcon />;
    t2 = <AccordionTitle />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== infocarData) {
    t3 = <Accordion indicator="button" indicatorOpenText="Apri la scheda" indicatorClosedText="Chiudi la scheda" onValueChange={_temp} items={[{
      id: ACCORDION_ID,
      icon: t1,
      title: t2,
      content: <AccordionContent infocarData={infocarData} />
    }]} />;
    $[2] = infocarData;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};

// --- Helpers
const TRACK_CONTENT = {
  '@id': 'sdrn:subito:classified:content:auto-infocar-brochure',
  '@type': 'Content'
};
const openAccordionTracking = () => {
  getOrCreatePulse()?.queueEvent({
    type: 'View',
    object: TRACK_CONTENT
  });
};
const closeAccordionTracking = () => {
  getOrCreatePulse()?.queueEvent({
    type: 'Hide',
    object: TRACK_CONTENT
  });
};
export { Infocar };
function _temp(items) {
  return items.includes(ACCORDION_ID) ? openAccordionTracking() : closeAccordionTracking();
}